import React from 'react';
import { LinearProgress } from '@mui/material';

import { getSpinnersToDisplay, useAppWithSpinnerMessagesSelector } from '@paragon/task-spinner';

interface Props {
  // Job grid does not use spinnerMessages. This is used to force the spinner.
  readonly forceSpinner?: boolean;
  // Changes the color of the spinner
  readonly spinnerColor?: 'primary' | 'secondary';
}

/**
 * A LinearSpinner whose visibility is tied to the existence of active tasks from @paragon/task-spinner.
 */
export function LinearTaskSpinner({ forceSpinner, spinnerColor }: Props) {
  const spinnerMessages = useAppWithSpinnerMessagesSelector(getSpinnersToDisplay);
  const color = spinnerColor || 'secondary';
  return !forceSpinner && spinnerMessages.size === 0 ? (
    <LinearProgress variant="determinate" color={color} value={100} />
  ) : (
    <LinearProgress color={color} />
  );
}
